// Supabase public.bank_key()와 같은 규칙. 지도 지점 이름과 공시 회사명을 맞추는 데 씁니다.
const ALIASES = [
  [/국민/, '국민'], [/(아이엠|im|대구|dgb)/, '대구'], [/(산업|kdb)/, '산업'], [/농협/, '농협'], [/(기업|ibk)/, '기업'],
  [/(스탠다드|sc제일|제일)/, 'sc제일'], [/(하나|keb)/, '하나'], [/(씨티|citi)/, '씨티'], [/수협/, '수협'], [/경남/, '경남'],
  [/부산/, '부산'], [/광주/, '광주'], [/전북/, '전북'], [/제주/, '제주'], [/신한/, '신한'], [/우리/, '우리'], [/카카오/, '카카오'],
  [/토스/, '토스'], [/(케이|kbank)/, '케이'],
];
const COOP = /(신협|신용협동조합|저축은행|새마을금고|축협|수협(?!은행)|산림조합)/;

export function bankKey(value) {
  const raw = String(value || '').trim();
  // 지점명은 첫 단어(은행명)만 사용: '신한은행 대구지점' → '신한은행'
  const first = raw.split(/\s+/)[0];
  const v = /(은행|뱅크|신협|농협|금고|저축|수협|축협|조합|bank)/i.test(first) ? first : raw;
  // 조합·저축은행은 이름 전체로 비교 ('대구대동신협'이 iM뱅크로, '자인농협'이 농협은행으로 묶이지 않도록)
  if (COOP.test(v) || (/농협/.test(v) && !/(농협은행|nh농협)/i.test(v))) return v.replace(/주식회사|㈜|\(주\)|\s/g, '').toLowerCase();
  const k = v.replace(/주식회사|저축은행|은행|뱅크|㈜|\s/g, '').toLowerCase();
  return ALIASES.find(([re]) => re.test(k))?.[1] ?? k;
}

// 지점(branchKey)이 상품 회사(productKey)와 같은 곳인지
export function sameBank(branchKey, productKey, sector) {
  if (!branchKey || !productKey) return false;
  return branchKey === productKey || (sector !== 'bank' && branchKey.includes(productKey)) || (sector === 'bank' && branchKey.length >= 2 && productKey.includes(branchKey));
}
